import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import api, { getOrderToken } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { OrderSummary } from "../components/OrderSummary";

const OrderConfirmation = () => {
  const { orderNumber } = useParams();
  const { t, lang } = useLanguage();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const token = getOrderToken(orderNumber);
    api
      .get(`/orders/${orderNumber}`, { params: token ? { token } : undefined })
      .then(({ data }) => setOrder(data))
      .catch(() => {});
  }, [orderNumber]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="order-confirmation-page">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }}>
        <CheckCircle2 size={56} strokeWidth={1} className="mx-auto text-brand-ink" />
      </motion.div>
      <h1 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-8">{t("order_received")}</h1>
      <p className="overline mt-6">{t("order_number")}</p>
      <p className="font-mono text-2xl text-brand-ink mt-1" data-testid="order-number">{orderNumber}</p>
      <p className="mt-6 text-brand-sub font-light">{t("order_thanks")}</p>

      {order && (
        <div className="mt-12 border border-brand-line p-8 text-left">
          <OrderSummary order={order} />
          <p className="mt-3 text-xs text-brand-muted">
            {lang === "en" ? "Payment" : "Ödəniş"}:{" "}
            {order.payment_method === "cod"
              ? (lang === "en" ? "Cash on delivery" : "Çatdırılma zamanı nağd")
              : t("pay_card")}
          </p>
        </div>
      )}

      <Link to="/" className="inline-block mt-12 bg-brand-ink text-white px-8 py-4 text-sm tracking-[0.12em] uppercase hover:bg-brand-oxid transition-colors" data-testid="back-home-btn">
        {t("back_home")}
      </Link>
    </div>
  );
};

export default OrderConfirmation;
